import  gql  from 'graphql-tag'

export const sessions = gql`query Sessions($name: String){
        sessions(name: $name){
        edges{
            node{
            id
            created
            revoked
            expirationTime
            user{
                name
                email
                surname
                username
                group{
                id
                name
                }
            }
            }
        }
        }
    }`;